import React, { useState, useEffect } from 'react';
import axios from 'axios';

function LeadGen() {
    // New: Load state from sessionStorage on component mount
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [scrapedResults, setScrapedResults] = useState([]);
    const [searchQuery, setSearchQuery] = useState(
        () => sessionStorage.getItem('leadGenSearchQuery') || ''
    );
    const [location, setLocation] = useState(
        () => sessionStorage.getItem('leadGenLocation') || 'Mumbai'
    );

    // New: Save searchQuery to sessionStorage whenever it changes
    useEffect(() => {
        sessionStorage.setItem('leadGenSearchQuery', searchQuery);
    }, [searchQuery]);

    // New: Save location to sessionStorage whenever it changes
    useEffect(() => {
        sessionStorage.setItem('leadGenLocation', location);
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!searchQuery) return;
        setLoading(true);
        setStatus({ type: '', message: '' });
        setScrapedResults([]);

        // Clear sessionStorage when a new search is submitted
        sessionStorage.removeItem('leadGenSearchQuery');
        sessionStorage.removeItem('leadGenLocation');

        try {
            console.log("Sending POST to /api/businesses/scrape with:", { searchQuery, location });

            const apiUrl = `${process.env.REACT_APP_BACKEND_URL}/api/businesses/scrape`;
            console.log("Using API URL:", apiUrl);

            const response = await axios.post(apiUrl, { searchQuery, location });

            console.log("Raw response:", response);
            const result = response.data;
            console.log("Scrape result data:", result);

            setStatus({ type: 'success', message: result.msg || 'Scraping initiated successfully!' });

            const businessesData = Array.isArray(result.businesses)
                ? result.businesses.map(item => item.data || item)
                : [];
            console.log("Parsed businessesData:", businessesData);
            setScrapedResults(businessesData);
        } catch (error) {
            if (error.response) {
                console.error("Backend error:", error.response.status, error.response.data);
                if (error.response.status === 404) {
                    alert(
                        "404 Not Found: The backend route /api/businesses/scrape exists, but scraping returned no results.\n\n" +
                        "Backend message: " + (error.response.data?.msg || "No message") +
                        "\n\nThis usually means:\n" +
                        "- JustDial changed their HTML and the scraper is not finding results.\n" +
                        "- JustDial is blocking your server (IP ban, CAPTCHA, etc).\n" +
                        "- The selectors in backend/services/scraper.js are outdated.\n\n" +
                        "Check your backend logs for 'Scraped X businesses...' or scraping errors."
                    );
                }
            } else {
                console.error("Error:", error.message);
            }
            const errorMessage = error.response?.data?.msg || error.message || 'Failed to initiate scraping.';
            setStatus({ type: 'error', message: errorMessage });
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <>
           
            {/* Main Content */}
            <div className="min-h-screen bg-gradient-to-br  py-8 px-4 flex flex-col items-center">
                <div className="bg-gray-800 rounded-2xl shadow-2xl max-w-3xl w-full p-8">
                    <h2 className="text-3xl font-extrabold text-center text-indigo-300 mb-2 drop-shadow-lg">
                        Search & Scrape JustDial
                    </h2>
                    <p className="text-gray-400 text-center mb-4">
                        Enter a business type (e.g., <span className="font-semibold text-indigo-200">"dentist"</span>) and a location to scrape listings from JustDial.com.
                    </p>
                    <div className="flex gap-4 justify-center mb-6">
                        <a href="/leadGen" className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded transition">Search & Scrape</a>
                        <a href="/stored-businesses" className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded transition">Stored Businesses</a>
                    </div>
                    <div className="mb-6">
                        <form
                            onSubmit={handleSubmit}
                            className="flex flex-col sm:flex-row gap-4 mt-4 items-stretch"
                        >
                            <div className="flex-2 w-full">
                                <label htmlFor="searchQuery" className="block text-gray-300 mb-1 font-medium">
                                    Search For (e.g., dentist)
                                </label>
                                <input
                                    id="searchQuery"
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    required
                                    disabled={loading}
                                    className="w-full px-4 py-3 rounded-lg border border-gray-600 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-base"
                                    placeholder="Business type"
                                />
                            </div>
                            <div className="flex-1 w-full">
                                <label htmlFor="location" className="block text-gray-300 mb-1 font-medium">
                                    Location (e.g., Mumbai, Delhi)
                                </label>
                                <input
                                    id="location"
                                    type="text"
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    required
                                    disabled={loading}
                                    className="px-4 py-3 rounded-lg border border-gray-600 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-base"
                                    placeholder="Location"
                                />
                            </div>
                            <div className="flex items-end w-full sm:w-auto">
                                <button
                                    type="submit"
                                    disabled={loading || !searchQuery}
                                    className={`w-full sm:w-auto py-3 px-6 rounded-lg font-bold text-lg text-white
                                bg-gradient-to-r from-indigo-600 to-purple-600
                                hover:from-indigo-700 hover:to-purple-700
                                focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800
                                transition-all duration-300 ease-in-out
                                shadow-lg hover:shadow-xl
                                disabled:opacity-50 disabled:cursor-not-allowed disabled:from-gray-500 disabled:to-gray-600`}
                                >
                                    {loading ? (
                                        <span className="flex items-center justify-center">
                                            <svg className="animate-spin h-6 w-6 text-white mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                                            </svg>
                                            Searching...
                                        </span>
                                    ) : 'Search & Scrape'}
                                </button>
                            </div>
                        </form>
                    </div>
                    {loading && (
                        <div className="flex flex-col items-center justify-center mt-6">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-indigo-500"></div>
                            <p className="mt-3 text-indigo-300 text-lg">Scraping in progress, please wait... This may take a moment.</p>
                        </div>
                    )}
                    {status && status.message && (
                        <div className={`mt-6 px-4 py-3 rounded text-center text-base font-semibold ${status.type === 'success'
                            ? 'bg-green-900 text-green-300'
                            : status.type === 'error'
                                ? 'bg-red-900 text-red-300'
                                : 'bg-indigo-900 text-indigo-300'
                            }`}>
                            {status.message}
                        </div>
                    )}
                    {!loading && scrapedResults && scrapedResults.length > 0 && (
                        <div className="mt-8">
                            <h3 className="text-2xl font-bold text-indigo-200 mb-4 text-center">Scraped Results:</h3>
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                                {scrapedResults.map((business) => (
                                    <div key={business._id || business.justDialUrl} className="bg-gray-700 rounded-xl shadow-lg p-4">
                                        <div className="bg-gray-800 rounded-xl shadow-lg p-5 flex flex-col min-h-[220px]">
                                            <h3 className="text-xl font-bold text-indigo-200 mb-2">{business.name}</h3>
                                            {/* Render other business details as needed */}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {!loading && (!status || !status.message) && (!scrapedResults || scrapedResults.length === 0) && (
                        <div className="mt-6 px-4 py-3 rounded bg-indigo-900 text-indigo-300 text-center text-base font-semibold">
                            No results to display yet. Enter a search query and location to begin scraping.
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default LeadGen;